import {
  IFieldFieldsFragment,
  ITagLeafField,
} from '../../../../utils/apollo/graphqlSchema';
import { usePanelStateContext } from '../context';
import { assertCondition } from '../../../../utils/types';
import { isNil } from 'lodash';
import Loading from '../panel/Loading';
import NestedFieldDetails from './NestedFieldDetails';
import {
  NodeDetailsMain,
  EntityTitle,
  NodeDetails,
  NodeDetailsHeader,
} from '../EntitySelectionPanelUI';
import { DescriptionIcon } from '../node/NodeIcon';
import { isNotBlank, isStructType } from '../utils';
import { IInlineBranchNode, INestedFieldEntity } from '../types';
import { IconWrapper } from '../../../Icon';
import EntityCategoryDetails from './EntityCategoryDetails';
import { UnreachableCaseError } from 'ts-essentials';
import NestedFieldKeyDetails from './NestedFieldKeyDetails';
import TableNames from './TableNames';
import NodeIsFavoriteIcon from '../node/NodeIsFavoriteIcon';
import NodeDetailsDescription from './NodeDetailsDescription';

interface IProps {
  node: ITagLeafField | IInlineBranchNode;
}

const getField = (
  selectedEntity: IFieldFieldsFragment | INestedFieldEntity,
) => {
  switch (selectedEntity.__typename) {
    case 'Field':
      return selectedEntity;
    case '__NestedFieldEntity':
      return selectedEntity.field;
    default:
      throw new UnreachableCaseError(selectedEntity);
  }
};

const FieldDetails = ({ node }: IProps) => {
  const { getEntityFromCache, selectNodeHandler, entityLoading } =
    usePanelStateContext();

  const selectedEntity = getEntityFromCache(node);

  if (entityLoading) {
    return <Loading />;
  } else if (!isNil(selectedEntity)) {
    assertCondition(
      selectedEntity.__typename === 'Field' ||
        selectedEntity.__typename === '__NestedFieldEntity',
    );

    const field = getField(selectedEntity);
    const { categories, tableNames } = field;

    return (
      <NodeDetails>
        <NodeDetailsHeader onClick={() => selectNodeHandler(node)}>
          <IconWrapper size={16}>
            <DescriptionIcon node={node} />
          </IconWrapper>
          <EntityTitle>{field.name}</EntityTitle>
          {field.isFavorite && <NodeIsFavoriteIcon />}
        </NodeDetailsHeader>
        <NodeDetailsMain>
          {tableNames.length > 0 && (
            <TableNames tableNames={tableNames.join(', ')} />
          )}
          {categories?.length > 0 && (
            <EntityCategoryDetails entityCategories={categories} />
          )}
          {isNotBlank(field.description) && (
            <NodeDetailsDescription description={field.description} />
          )}
        </NodeDetailsMain>
        {selectedEntity.__typename === '__NestedFieldEntity' &&
          (node.__typename === 'TagInlineBranch' ||
            node.__typename === 'TagFieldInlineBranch') &&
          !isStructType(selectedEntity.field.type) && (
            <NestedFieldDetails entity={selectedEntity} node={node} />
          )}
        {selectedEntity.__typename === 'Field' &&
          !isNil(selectedEntity.nestedFieldMetadata) &&
          !isStructType(selectedEntity.nestedFieldMetadata.type) && (
            <NestedFieldKeyDetails entity={selectedEntity} />
          )}
      </NodeDetails>
    );
  }

  return null;
};
export default FieldDetails;
